<template>
  <div class="wrapper">
    <div>案件・キャンペーン管理</div>
    <!-- eslint-disable-next-line vue/require-component-is -->
    <InsertionOrdersTable
      :items="insertionOrderList"
      :loading="loading"
      :sales-account-list="salesAccountList"
      :advertiser="advertiser"
      :can-edit="canEdit"
      :inventory-lists="inventoryLists"
      :system-owner="systemOwner"
      :is-advertiser="isAdvertiser"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { InsertionOrdersModel } from '@/models/InsertionOrders'
import InsertionOrdersTable from '@/components/Advertiser/Operation/IO/IOTable'
import {
  actions,
  getters,
} from '@/vuex/modules/advertiser/insertionOrders/constants'
import { getters as currentAdvertiserGetter } from '@/vuex/modules/currentAdvertiser/constants'
import { mapActions } from 'vuex'
import { getters as accountGetters } from '@/vuex/modules/account/constants'
import { accountInitializer } from '@/mixins/accountInitializer'
import { setDrawerTypeAdvertiser } from '@/mixins/setDrawerTypeAdvertiser'
import { setToolbarTypeAdvertiser } from '@/mixins/setToolBarTypeAdvertiser'
import AdvertiserRepository from '@/models/Advertiser/AdvertiserRepository'

export default {
  name: 'InsertionOrders',
  // eslint-disable-next-line vue/no-unused-components
  components: { InsertionOrdersTable },
  mixins: [
    accountInitializer,
    setDrawerTypeAdvertiser,
    setToolbarTypeAdvertiser,
  ],
  computed: {
    ...mapState('advertiser/insertionOrders', ['query']),
    advertiser() {
      return this.$store.getters[currentAdvertiserGetter.currentAdvertiser]
    },
    insertionOrderList() {
      const items = this.$store.getters[getters.searchResult].items
      if (items) {
        return items.map(item => new InsertionOrdersModel(item))
      }
      return []
    },
    keyword() {
      return ''
    },
    loading() {
      return this.$store.getters[getters.loading]
    },
    salesAccountList() {
      return this.$store.getters[getters.salesAccountList]
    },
    permissionLevel() {
      return this.$store.getters[getters.permissionLevel]
    },
    canEdit() {
      return this.permissionLevel === 'edit'
      // admin || operatorだとeditが返ってくる。↓参照
      // @/vuex/modules/advertiser/insertionOrders/getters.js
    },
    breadCrumbList() {
      return [{ title: 'キャンペーン管理', path: null }]
    },
    inventoryLists() {
      return this.$store.getters['advertiser/insertionOrders/inventoryLists']
    },
    systemOwner() {
      return this.$store.getters[accountGetters.systemOwner]
    },
    isAdvertiser() {
      return this.$store.getters[accountGetters.isAdvertiser]
    },
    hasAdminPermissionForAdvertiser() {
      if (!this.advertiser) return true
      if (this.advertiser.hasAdminPermission) return true
      return false
    },
  },
  created() {
    this.getSalesAccountList()
    // advertiserがinactiveのときに警告する
    if (!this.advertiser.isActive) this.showWarning()
  },
  methods: {
    ...mapActions('currentAdvertiser', {
      getCurrentAdvertiser: 'GET',
    }),
    ...mapActions('snackbar', {
      showSnackbarSuccess: 'SHOW_SNACKBAR_SUCCESS',
    }),
    ...mapActions('loader', {
      showLoader: 'SHOW',
      hideLoader: 'HIDE',
    }),
    /**
     * advertiserがinactiveなアカウントに対して警告を出す
     */
    async showWarning() {
      if (this.hasAdminPermissionForAdvertiser) {
        await this.showWarningForWithAdminAccount()
      } else {
        await this.showWarningForNoAdminAccount()
      }
    },
    // advertiserへのadmin権限がない場合に表示する警告
    async showWarningForNoAdminAccount() {
      await this.$confirm('【注意】', {
        okText: '閉じる',
        body:
          '広告主のステータスが「無効」になっています。\n' +
          '広告配信をする場合、広告主のステータスを「有効」に切り替えるよう代理店・システム管理者に依頼して下さい',
        onlyOk: true,
      })
    },
    // advertiserへのadmin権限がある場合に表示する警告
    async showWarningForWithAdminAccount() {
      const ret = await this.$confirm('【注意】', {
        okText: '有効化する',
        cancelText: '閉じる',
        body:
          '広告主のステータスが「無効」になっています。\n' +
          '広告配信する場合、広告主を有効化してください。',
      })
      if (ret) {
        this.showLoader()
        try {
          // advertiserを有効化する
          const advertiserId = this.advertiser.id
          await AdvertiserRepository.changeStatus(advertiserId, 'active')
          await this.getCurrentAdvertiser({ advertiserId })
          this.hideLoader()
          this.showSnackbarSuccess('広告主のステータスを有効にしました。')
        } catch (e) {
          this.hideLoader()
          throw new Error('有効化に失敗しました')
        }
      }
    },
    getSalesAccountList() {
      this.$store.dispatch(
        actions.GET_SALES_ACCOUNT_LIST,
        Number(this.$route.params.advertiserId),
      )
    },
  },
}
</script>

<style scoped lang="scss">
.wrapper {
  width: 100%;
}
</style>
